"use client";
import { CircleNotchIcon } from "@phosphor-icons/react";
import { FormEvent, ReactNode } from "react";

export interface FormProps {
  children?: ReactNode;
  loading?: boolean;
  markdown?: boolean;
  submitCopy?: string;
  onSubmit?: (e: FormEvent<HTMLFormElement>) => void;
  onChange?: (e: FormEvent<HTMLFieldSetElement>) => void;
}

const Form = ({ loading, children, onSubmit, submitCopy }: FormProps) => {
  return (
    <form
      className="flex flex-col gap-4 items-center md:items-start justify-center"
      onSubmit={(e) => {
        e.preventDefault();
        if (onSubmit) {
          onSubmit(e);
        }
      }}
    >
      <fieldset className="w-full flex flex-col gap-4">{children}</fieldset>
      <button
        type="submit"
        disabled={loading}
        className="button primary dark bright flex items-center gap-2"
      >
        {loading ? "Sending..." : submitCopy || "Submit"}
        {loading && (
          <span>
            <CircleNotchIcon
              className="animate-spin"
              size={22}
              weight="bold"
              aria-hidden="true"
            />
          </span>
        )}
      </button>
    </form>
  );
};

export { Form };
